<!-- 药店报货 -->
<template>
  <div
    class="content"
    v-if="isInitConfig"
    v-loading.fullscreen.lock="submitLoading"
  >
    <div class="search-area pt1">
      <p class="t-left font-S16">基本信息</p>
      <el-row :gutter="24">
        <!--报货时间 -->
        <el-col
          :span="8"
          v-if="getFieldConfig('inputTime', 'formVisible') == 'Y'"
        >
          <div class="search-area-div w90">
            <span
              v-if="getFieldConfig('inputTime', 'isRequired') == 'Y'"
              class="fontC-red"
              >*</span
            >{{ getFieldConfig("inputTime", "fieldAlias") }}：
          </div>
          <el-date-picker
            class="ipt-sty"
            value-format="yyyy-MM-dd"
            v-model="inputTime"
            @change="getVisitTime"
            :clearable="false"
            :picker-options="datePickerOptions"
          >
          </el-date-picker>
        </el-col>
        <!--任务 -->
        <el-col :span="8" v-if="!$route.query.guid">
          <div class="search-area-div w90">
            <span v-if="taskList.length > 0" class="fontC-red">*</span
            >选择任务：
          </div>
          <el-select
            class="ipt-sty"
            v-model="taskTitleAndTaskContentName"
            placeholder="请选择任务"
            filterable
            style="width: 300px"
            @change="taskChange"
          >
            <el-option
              v-for="item in taskList"
              :key="item.taskTitleAndTaskContentName"
              :label="item.taskTitleAndTaskContentName"
              :value="item.taskTitleAndTaskContentName"
            ></el-option>
          </el-select>
        </el-col>
        <!--选择药店 -->
        <el-col
          :span="8"
          v-if="getFieldConfig('customerName', 'formVisible') == 'Y'"
        >
          <div class="search-area-div w90">
            <span
              v-if="getFieldConfig('customerName', 'isRequired') == 'Y'"
              class="fontC-red"
              >*</span
            >{{ getFieldConfig("customerName", "fieldAlias") }}：
          </div>
          <el-input
            @focus="openMedDialog"
            class="ipt-sty"
            type="text"
            v-model="page.customerName"
            autocomplete="off"
            placeholder="点击选择"
          ></el-input>
        </el-col>

        <!-- </el-row>
      <el-row :gutter="24" class="mt15"> -->
        <!--商业公司 -->
        <el-col
          :span="8"
          v-if="getFieldConfig('franchiseeName', 'formVisible') == 'Y'"
        >
          <div class="search-area-div w90">
            <span
              v-if="getFieldConfig('franchiseeName', 'isRequired') == 'Y'"
              class="fontC-red"
              >*</span
            >{{ getFieldConfig("franchiseeName", "fieldAlias") }}：
          </div>
          <el-input
            @focus="openFranchiseeDialog"
            class="ipt-sty"
            type="text"
            v-model="page.franchiseeName"
            autocomplete="off"
            placeholder="点击选择"
          ></el-input>
        </el-col>
        <!--报货类型 -->
        <el-col
          :span="8"
          v-if="
            getFieldConfig('orderType', 'formVisible') == 'Y' &&
            !$route.query.guid
          "
        >
          <div class="search-area-div w90">
            <span
              v-if="getFieldConfig('orderType', 'isRequired') == 'Y'"
              class="fontC-red"
              >*</span
            >{{ getFieldConfig("orderType", "fieldAlias") }}：
          </div>
          <el-select
            v-model="page.orderType"
            placeholder="请选择"
            class="ipt-sty"
          >
            <el-option
              v-for="item in reportType"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div class="button-area pt1 f-hidden">
      <p class="t-left font-S16">产品信息</p>
      <el-button
        icon="el-icon-plus"
        class="fl"
        size="mini"
        type="info"
        @click="add(1, '')"
        >选择产品</el-button
      >
      <el-button size="mini" class="fl mr10" type="info" @click="downTemplate()"
        >下载导入模板</el-button
      >
      <el-upload
        class="upload-demo fl t-left"
        action="#"
        multiple
        :limit="1"
        accept=".xlsx,.xsl,.xls,.xlsm"
        :before-upload="beforeUpload"
        :on-exceed="handleExceed"
        :http-request="changeFile"
        :file-list="fileList"
        :show-file-list="false"
      >
        <el-button
          size="mini"
          type="info"
          icon="el-icon-plus"
          v-loading.fullscreen.lock="fullscreenLoading1"
          >批量导入产品</el-button
        >
      </el-upload>
      <el-button size="mini" class="fl ml10" type="danger" @click="empty"
        >清空产品</el-button
      >
      <div class="task-tips" v-if="taskGuid">
        <span>{{ taskTitle }}-{{ taskContentName }}:</span>
        <span>
          计划完成：
          <b style="color: red; font-weight: normal">
            {{ planCount.toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/, "$1") }}
          </b>
          {{ taskTotalUnit }}
        </span>
        <span>
          实际完成：
          <b style="color: red; font-weight: normal">
            {{ realCount.toFixed(2).replace(/(?:\.0*|(\.\d+?)0+)$/, "$1") }}
          </b>
          {{ taskTotalUnit }}
          <el-tooltip
            class="item"
            effect="dark"
            content="本次填写数量提交后才累加"
            placement="right-start"
            ><i class="el-icon-question"></i></el-tooltip
        ></span>
      </div>
    </div>
    <div class="back-color-fff content-main-box" style="padding: 0 16px">
      <el-table
        :data="
          goodsList.slice(
            (pageTable.pageIndex - 1) * pageTable.pageSize,
            pageTable.pageIndex * pageTable.pageSize
          )
        "
        style="width: 100%"
        row-key="guid"
        border
      >
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{
              (pageTable.pageIndex - 1) * pageTable.pageSize + scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="产品"
          header-align="center"
          align="left"
          width="230"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="product">
              <img
                class="product-img"
                :src="scope.row.pictContent | filterImgUrl"
                alt=""
              />
              <p class="product-text">{{ scope.row.goodsName }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsCode"
          label="产品编码"
          header-align="center"
          align="center"
          width="130"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="goodsSpec"
          label="规格"
          header-align="center"
          align="left"
          width="230"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="producer"
          label="生产企业"
          header-align="center"
          align="center"
          width="180"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="price"
          label="单价"
          header-align="center"
          align="right"
          width="140"
        >
          <template slot-scope="scope">
            <span v-if="isChangePrice == 1">
              <el-input
                class="price-input"
                :placeholder="
                  scope.row.priceType == '2'
                    ? (scope.row.minPrice || 0) + '~' + scope.row.maxPrice
                    : '请输入'
                "
                v-model="scope.row.price"
                @change="priceChange(scope.row)"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '');"
              ></el-input>
            </span>
            <span v-else class="price-input">{{
              scope.row.price | numDigit | numFmt
            }}</span>
            <span v-show="scope.row.tip" class="tip-class">
              {{ scope.row.tip }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bigUnitQty"
          label="数量"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <div class="qty-wrap">
              <div class="btn btn0" @click="subAddQty(0, scope.$index)">-</div>
              <el-input
                v-model="scope.row.bigUnitQty"
                @change="handleCounterChange"
                oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,4})?/)"
                size="small"
              ></el-input>
              <div class="btn btn1" @click="subAddQty(1, scope.$index)">+</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="declareGoodsType == '2' && isCompetitor == 'N'"
          prop="goodsLotNo"
          label="批号"
          header-align="center"
          align="left"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="declareGoodsType == '2' && isCompetitor == 'N'"
          prop="goodsProductDate"
          label="生产日期"
          header-align="center"
          align="left"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          v-if="declareGoodsType == '2' && isCompetitor == 'N'"
          prop="goodsExpiryDate"
          label="有效期"
          header-align="center"
          align="left"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="unitStyle"
          label="单位"
          header-align="center"
          align="center"
          width="70"
        ></el-table-column>
        <el-table-column
          label="小计（元）"
          header-align="center"
          align="right"
          width="120"
        >
          <template slot-scope="scope">
            {{ (scope.row.bigUnitQty * scope.row.price) | numFmt | numDigit }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="70"
        >
          <template slot-scope="scope">
            <a
              class="txt-color-red"
              @click="getDelete(scope.$index, scope.row)"
            >
              删除
            </a>
          </template>
        </el-table-column>
        <div slot="empty">
          <p class="mt80">
            <img class="no-data" src="../../assets/images/no_data.png" />
          </p>
          <p><span>暂无数据</span></p>
        </div>
      </el-table>
      <el-pagination
        v-if="goodsList && goodsList.length > 0"
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 50, 100]"
        :current-page="pageTable.pageIndex"
        :page-size="pageTable.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTable.totalRows"
      >
      </el-pagination>
    </div>
    <div class="button-area pr16 pb">
      <p class="t-left font-S16">备注信息</p>
      <el-input
        type="textarea"
        v-model="page.memo"
        class="w35f mb64"
        :autosize="{ minRows: 4, maxRows: 4 }"
      ></el-input>
    </div>
    <div class="bottom-total" v-show="!dialogFormVisible">
      <div class="total-left t-left fl">
        <p>
          <span class="mr30">
            合计：
            <span v-if="goodsList && goodsList.length > 0">
              品种<span class="fontC-4fa1a4"> {{ pingzhongSum }} </span>
              <span class="mr30"> 个 </span>
              数量<span class="fontC-4fa1a4">{{ num }} </span>
              <span class="mr30"> 件 </span>
              金额
              <span class="fontC-4fa1a4"
                >{{ amount | numFmt | numDigit }}
              </span>
              <span class="mr30"> 元 </span>
              大写：{{ amount | smallToBig }}
            </span>
          </span>
          <span v-if="goodsList && goodsList.length == 0">无</span>
        </p>
        <!-- <p class="line-h7">
          <b class="fontC-4fa1a4"> {{ goodsList.length }} </b> 个品种，合计
          <b class="fontC-4fa1a4"> {{ amount | numFmt | numDigit }} </b> 元
        </p>
        <p class="line-h7">
          大写：<span class="fontC-red">{{ amount | smallToBig }}</span>
        </p> -->
      </div>
      <div class="total-right fr">
        <el-button
          v-if="$route.query.guid"
          size="mini"
          class="mr30 mt15"
          @click="$router.go(-1)"
          >取消</el-button
        >
        <el-button size="mini" type="info" class="mr30 mt15" @click="submit"
          >提交</el-button
        >
      </div>
    </div>
    <el-dialog
      @close="cancelDialog"
      title="选择产品"
      :visible.sync="dialogFormVisible"
      width="900px"
    >
      <el-row :gutter="24" class="mb30">
        <el-col :span="13">
          <div class="search-area-div w80">产品名称：</div>
          <el-input
            v-model="pages.goodsName"
            class="ipt-sty"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-button size="mini" type="info" @click="searchData()"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="productInformationList"
        style="width: 100%"
        row-key="guid"
        border
        @selection-change="handleSelectionChange"
        @row-click="handleClickPro"
        @select="handleSelectPro"
        v-loading="loading"
        ref="dataTable"
      >
        <el-table-column
          v-if="!(declareGoodsType == '2' && isCompetitor == 'N')"
          type="selection"
          width="55"
          :selectable="selectDisableRoom"
          :reserve-selection="true"
        >
        </el-table-column>
        <!-- <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="goodsName"
          label="产品"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="product">
              <img
                class="product-img"
                :src="scope.row.pictContent | filterImgUrl"
                alt=""
              />
              <p class="product-text w247">{{ scope.row.goodsName }}</p>
            </div>
            <p
              class="select-tip"
              v-show="
                (isChangePrice == 0 && scope.row.priceType == 2) ||
                (isChangePrice == 0 &&
                  scope.row.priceType == 1 &&
                  scope.row.price == 0) ||
                (isChangePrice == 0 &&
                  scope.row.priceType == 1 &&
                  !scope.row.price)
              "
            >
              无法加购，请联系运营是否需要支持自行填价
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsSpec"
          label="规格"
          header-align="center"
          align="left"
          width="170"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="producer"
          label="生产企业"
          header-align="center"
          align="center"
          width="170"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="price"
          label="单价"
          header-align="center"
          align="right"
          width="120"
        >
          <template slot-scope="scope">
            <!-- 固定价 -->
            <span
              v-if="
                scope.row.priceType == '1' &&
                scope.row.price !== 0 &&
                scope.row.price
              "
              >{{ scope.row.price | numDigit | numFmt }}</span
            >
            <!-- 区间价 -->
            <span v-if="scope.row.priceType == '2'">
              {{ scope.row.price | numDigit | numFmt }}~{{
                scope.row.maxPrice | numDigit | numFmt
              }}
            </span>
            <span
              v-if="
                scope.row.priceType == '1' &&
                (scope.row.price == 0 || !scope.row.price)
              "
              >未定价</span
            >
          </template>
        </el-table-column>
        <!-- 嵌套表start -->
        <el-table-column type="expand" width="1">
          <template slot-scope="prop">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-table
                :ref="'nestedTable-' + prop.$index"
                @select="selectChild"
                @select-all="selectChildAll($event, prop.row)"
                @selection-change="
                  handleChildSelectionChange($event, prop.row, prop.$index)
                "
                :data="prop.row.goodsLotList"
                stripe
                border
                max-height="250"
              >
                <el-table-column
                  type="selection"
                  width="55"
                  :reserve-selection="true"
                >
                </el-table-column>
                <el-table-column
                  prop="goodsLotNo"
                  label="产品批号"
                  width="130"
                  header-align="center"
                  align="left"
                >
                </el-table-column>
                <el-table-column
                  prop="goodsProductDate"
                  label="生产日期"
                  width="210"
                  header-align="center"
                  align="left"
                >
                  <template slot-scope="scopeChild">{{
                    scopeChild.row.goodsProductDate | getDate
                  }}</template>
                </el-table-column>
                <el-table-column
                  prop="goodsExpiryDate"
                  label="有效期"
                  width="210"
                  header-align="center"
                  align="left"
                >
                  <template slot-scope="scopeChild">{{
                    scopeChild.row.goodsExpiryDate | getDate
                  }}</template>
                </el-table-column>
              </el-table>
            </el-form>
          </template>
        </el-table-column>
        <!-- 嵌套表end -->
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="pages.pageIndex"
        :page-size="pages.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pages.totalRows"
      >
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <p class="t-left fl">本次已选择{{ multipleSelection.length }}个产品</p>
        <el-button plain size="mini" @click="cancelDialog">取消</el-button>
        <el-button size="mini" type="info" @click="submitForm()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      class="taskDialog"
      title="您有多个任务，请选择一个"
      :visible.sync="taskDialogVisible"
      width="500px"
    >
      <template v-if="taskDialogVisible">
        <el-form
          label-width="120px"
          :label-position="right"
          class="demo-ruleForm"
        >
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择任务：</span>
            <el-select
              v-model="taskTitleAndTaskContentName"
              placeholder="请选择任务"
              filterable
              class="fl"
              style="width: 300px"
              @change="taskChange"
            >
              <el-option
                v-for="item in taskList"
                :key="item.taskTitleAndTaskContentName"
                :label="item.taskTitleAndTaskContentName"
                :value="item.taskTitleAndTaskContentName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="taskTitleAndTaskContentName">
            <span slot="label" style="color: red"></span>
            <span slot="label">执行日期：</span>
            <div class="fl">
              {{ startTime | getDate }}至{{ endTime | getDate }}
            </div>
          </el-form-item>
          <el-form-item v-if="taskTitleAndTaskContentName">
            <span slot="label" style="color: red"></span>
            <span slot="label">计划完成：</span>
            <div class="fl">{{ planCount }}{{ taskTotalUnit }}</div>
          </el-form-item>
          <el-form-item v-if="taskTitleAndTaskContentName">
            <span slot="label" style="color: red"></span>
            <span slot="label">实际完成：</span>
            <div class="fl">{{ realCount }}{{ taskTotalUnit }}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" plain @click="taskDialogVisible = false"
            >取 消</el-button
          >
          <el-button size="mini" type="info" @click="sureTask">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 导入 -->
    <el-dialog
      title="批量导入"
      :visible.sync="showImport"
      width="800px"
      class="importClass"
    >
      <div class="secondStep">
        <p class="line1" v-if="importResult.error == '0'">
          数据导入完成，请核对！
        </p>
        <p class="line1" v-else>数据导入完成，请核对！</p>
        <p class="line2">
          共导入数据 <span> {{ importResult.total }} </span> 条，导入成功
          <span>{{ importResult.ok }} </span> 条
          <span v-if="importResult.error > 0"
            >，失败<span> {{ importResult.error }} </span> 条。</span
          >
        </p>
        <p class="line3" @click="downFailData" v-if="importResult.error > 0">
          下载导入失败数据
        </p>
      </div>
    </el-dialog>

    <!-- 选择药店开始 -->
    <el-dialog
      class="med-wrap"
      title="选择药店"
      :visible.sync="medDialog"
      :modal-append-to-body="false"
      width="900px"
    >
      <el-row :gutter="24" class="mb30">
        <el-col :span="10">
          <div class="search-area-div w80">药店名称：</div>
          <el-input
            v-model="medQueryPage.customerName"
            class="ipt-sty"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :span="10" v-if="isEsQuery == 'Y'">
          <div class="search-area-div w80">所在区域：</div>
          <el-cascader
            class="ipt-sty"
            ref="cascaderAddr"
            placeholder="请选择"
            collapse-tags
            :options="provinceAndCityData"
            :props="{ multiple: true, checkStrictly: false }"
            filterable
            @change="handleMedProvinceAndCity"
          ></el-cascader>
        </el-col>
        <el-col :span="4">
          <el-button size="mini" type="info" @click="getMedList(1)"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="medList"
        style="width: 100%"
        :row-key="isEsQuery == 'N' ? 'guid' : 'commonGuid'"
        border
        v-loading="loading"
        ref="medTableRef"
        @row-click="handleClickMed"
        @select="handleSelectMed"
      >
        <el-table-column
          type="selection"
          width="60"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{
              (medQueryPage.pageIndex - 1) * medQueryPage.pageSize +
              scope.$index +
              1
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="medName"
          label="药店名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.medName || scope.row.customerName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="venue"
          label="所在区域"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.commonGuid"
              >{{ scope.row.provinceName
              }}{{ scope.row.cityName ? "/" + scope.row.cityName : ""
              }}{{
                scope.row.districtName ? "/" + scope.row.districtName : ""
              }}</span
            >
            <span v-else>{{ scope.row.venue || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="详细地址"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.address || "-" }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleMedSizeChange"
        @current-change="handleMedCurrentChange"
        :page-sizes="[10, 30, 50]"
        :current-page="medQueryPage.pageIndex"
        :page-size="medQueryPage.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="medQueryPage.totalRows"
      >
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="medDialog = false">取消</el-button>
        <el-button size="mini" type="info" @click="medSure()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 选择药店结束 -->

    <!-- 选择商业公司开始 -->
    <el-dialog
      class="med-wrap"
      title="选择商业公司"
      :visible.sync="franchiseeDialog"
      :modal-append-to-body="false"
      width="900px"
    >
      <el-row :gutter="24" class="mb30">
        <el-col :span="10">
          <div class="search-area-div w80">商业公司：</div>
          <el-input
            v-model="franchiseeQueryPage.franchiseeName"
            class="ipt-sty"
            placeholder="请输入"
          ></el-input>
        </el-col>
        <el-col :span="10" v-if="isEsQuery == 'Y'">
          <div class="search-area-div w80">所在区域：</div>
          <el-cascader
            class="ipt-sty"
            ref="cascaderAddr"
            placeholder="请选择"
            collapse-tags
            :options="provinceAndCityData"
            :props="{ multiple: true, checkStrictly: false }"
            filterable
            @change="handleFranchiseeProvinceAndCity"
          ></el-cascader>
        </el-col>
        <el-col :span="4">
          <el-button size="mini" type="info" @click="getFranchiseeList(1)"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="franchiseeList"
        style="width: 100%"
        row-key="guid"
        border
        v-loading="loading"
        ref="franchiseeTableRef"
        @select="handleSelectFranchisee"
        @row-click="handleClickFranchisee"
      >
        <el-table-column
          type="selection"
          width="60"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{
              (franchiseeQueryPage.pageIndex - 1) *
                franchiseeQueryPage.pageSize +
              scope.$index +
              1
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="franchiseeName"
          label="商业公司名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.franchiseeName || scope.row.customerName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="venue"
          label="所在区域"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.commonGuid"
              >{{ scope.row.provinceName
              }}{{ scope.row.cityName ? "/" + scope.row.cityName : ""
              }}{{
                scope.row.districtName ? "/" + scope.row.districtName : ""
              }}</span
            >
            <span v-else>{{ scope.row.venue || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="详细地址"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleFranchiseeSizeChange"
        @current-change="handleFranchiseeCurrentChange"
        :page-sizes="[10, 30, 50]"
        :current-page="franchiseeQueryPage.pageIndex"
        :page-size="franchiseeQueryPage.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="franchiseeQueryPage.totalRows"
      >
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="franchiseeDialog = false"
          >取消</el-button
        >
        <el-button size="mini" type="info" @click="franchiseeSure()"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 选择商业公司结束 -->
  </div>
</template>
<script>
import areaJson from "../../assets/js/china_address_v4s.js";
import holiday from "../mixins/holiday";
import getTenantDetail from "../mixins/getTenantDetail";
import { ServiceProviderTypeEnum } from "../mixins/getTenantDetail";
import { getAccountMonthFullAreaWithAmount } from '@/api/msConfigureService.js';
let userInfo = JSON.parse(localStorage.userInfo);
export default {
  mixins: [holiday, getTenantDetail],
  data() {
    return {
      showImport: false,
      importResult: {
        total: 0,
        ok: 0,
        error: 1,
      },
      num: 0,
      url:
        `/${serverConfig.msPurchaseService}/order/data/cast-order-temp-data?tenantGuid=` +
        this.$store.state.guid,
      productInformationList: [],
      bigUnitQty: 0,
      datePickerOptions: {
        disabledDate: (time) => {
          const { taskStartTime, taskEndTime } = this.$route.query;
          const minDate = this.$moment(taskStartTime).toDate();
          const maxDate = this.$moment(taskEndTime).toDate();
          return (
            time.getTime() < minDate.getTime() ||
            time.getTime() > maxDate.getTime()
          );
        },
      },
      pageTable: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      page: {
        tenantGuid: "",
        orderNo: "",
        inputTime: "",
        customerGuid: "",
        customerName: "",
        customerType: "1", //BHOTC药店1 BHSY2
        orderType: "报货",
        memo: "",
        orderDetails: [],
        franchiseeGuid: null,
      },
      pages: {
        pageIndex: 1,
        tenantGuid: "",
        pageSize: 10,
        goodsName: "",
        isPrescription: "",
        staffGuid: "",
        totalPage: 0,
        totalRows: 0,
      },
      reportType: [
        { name: "报货", value: "报货" },
        { name: "退货", value: "退货" },
      ],
      showBottom: true,
      textTitle: "",
      dialogFormVisible: false,
      right: "",
      multipleSelection: [],
      loading: false,
      optionsMedical: [],
      optionsFranchisee: [], //商业公司下拉选择
      goodsList: [],
      amount: 0,
      customerGuid: "",
      inputTime: "",
      submitLoading: false,
      selectLoading: false,
      fullscreenLoading1: false,
      fileList: [],

      taskList: [],
      taskDialogVisible: false,
      taskTitleAndTaskContentName: "",
      startTime: "",
      endTime: "",
      realCount: "",
      planCount: "",
      taskGuid: "",
      taskDetailGuid: "",
      taskTotalUnit: "",
      medQueryPage: {
        salesTerritoryGuidList: userInfo.salesTeritorys || null,
        customerName: "",
        pageSize: 10,
        pageIndex: 1,
        tenantGuid: this.$store.state.guid,
        provinces: [],
        city: [],
      },
      medDialog: false,
      medList: [],
      currentMedSelect: [],
      currentMedSelectRow: {},
      provinceAndCityData: areaJson,
      franchiseeQueryPage: {
        pageSize: 10,
        pageIndex: 1,
        franchiseeName: "",
        tenantGuid: this.$store.state.guid,
        provinces: [],
        city: [],
      },
      franchiseeDialog: false,
      franchiseeList: [],
      currentFranchiseeSelect: [],
      currentFranchiseeSelectRow: {},
      isInitConfig: false,
      isEsQuery: "N",
      taskContentJson: null,
      checkProFlg: 0,
      multipleChildSelection: [],
      declareGoodsType: "1", //采集方式
      isCompetitor: "N",
      accountMonth: "",
      isIntercept: false,
    };
  },
  computed: {
    /**是否是 三方接包服务商*/
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } =
          this.Mixins_tenantDetail.servicerCredential;
        return (
          serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR
        );
      } catch (error) {
        console.log(error);
      }
    },
    pingzhongSum() {
      let checkItem = this.goodsList;
      let num = 0;
      if (this.declareGoodsType == "2" && this.isCompetitor == "N") {
        let guidSet = new Set();
        checkItem.forEach((item) => {
          guidSet.add(item.goodsGuid);
        });
        num = guidSet.size;
      } else {
        num = checkItem.length;
      }
      return num;
    },
  },
  async created() {
    await this.Mixins_getServiceProviderType();

    localStorage.removeItem("holidayYears"); //初始化：用于判断是否重新获取节假日
    // 列表
    await this.getFormConfig();
    if (this.$route.query.guid) {
      await this.getDetail();
    } else {
      this.getNowTime();
      await this.getTaskList(this.inputTime);
      await this.getMedical("");
      await this.getAccepted("");
    }
    this.getAccountMonth();
  },
  watch: {
    "page.franchiseeGuid"(newVal, oldVal) {
      if (newVal) {
        this.checkProduct();
      }
    },
    "page.customerGuid"(newVal, oldVal) {
      if (newVal) {
        this.checkProduct();
      }
    },
    "page.orderType"(newVal, oldVal) {
      if (newVal) {
        this.checkProduct();
      }
    },
    goodsList: {
      // immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.checkProduct();
        }
      },
    },
  },
  methods: {
    async setDatePickerOptions(collectDateRule) {
      let refDate;
      if (this.$route.query.guid && this.$route.query.accountMonth) {
        refDate = this.$moment(this.$route.query.accountMonth, 'YYYYMM').format('YYYY-MM-01');
      } else {
        if (!this.inputTime) return;
        refDate = this.inputTime;
      }
      const params = {
        date: refDate,
        tenantGuid: localStorage.guid,
        amount: collectDateRule.amount || 0,
        includeCurrentMonth: collectDateRule.includeCurrentMonth ? 'Y' : 'N',
      };
      const { data } = await getAccountMonthFullAreaWithAmount(params);
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      const { startTime, endTime } = data.data;
      if (!startTime && !endTime) return;
      const today = this.$moment().startOf('day').valueOf();
      const endMs = this.$moment(endTime).valueOf();
      const isCurrentPeriod = endMs > today;

      this.datePickerOptions = {
        disabledDate: (time) => {
          const minDate = this.$moment(startTime).startOf('day').toDate();
          const maxDate = isCurrentPeriod ? new Date(today) : this.$moment(endTime).endOf('day').toDate();
          return time.getTime() < minDate.getTime() || time.getTime() > maxDate.getTime();
        },
      };
      if (!isCurrentPeriod && !this.$route.query.guid) {
        this.inputTime = this.$moment(startTime).format('YYYY-MM-DD');
      }
      if (isCurrentPeriod && !this.$route.query.guid) {
        this.inputTime = this.$moment(today).format('YYYY-MM-DD');
      }
    },
    setDatePickerByTaskRange() {
      if (!this.startTime || !this.endTime) {
        const minDate = this.$moment(this.$route.query.taskStartTime).toDate();
        const maxDate = this.$moment(this.$route.query.taskEndTime).toDate();
        this.startTime = minDate;
        this.endTime = maxDate;
      }
      const todayMs = this.$moment().startOf('day').valueOf();
      const taskStartMs = this.$moment(this.startTime).valueOf();
      const taskEndMs = this.$moment(this.endTime).valueOf();
      const maxMs = taskEndMs > todayMs ? todayMs : taskEndMs;
      this.datePickerOptions = {
        disabledDate: (time) => {
          const minDate = this.$moment(this.startTime).startOf('day').toDate();
          const maxDate = this.$moment(maxMs).endOf('day').toDate();
          return time.getTime() < minDate.getTime() || time.getTime() > maxDate.getTime();
        },
      };
      if (!this.$route.query.guid) {
        if (todayMs >= taskStartMs && todayMs <= taskEndMs) {
          this.inputTime = this.$moment().format('YYYY-MM-DD');
        } else {
          this.inputTime = this.$moment(this.startTime).format('YYYY-MM-DD');
        }
      }
    },
    //校验产品重复
    async checkProduct() {
      let self = this;
      let isCheckRepeat =
        JSON.parse(localStorage.getItem("BHOTC_bizParam"))
          ?.orderRepeatIntercept || true;
      if (!isCheckRepeat) return; //不拦截直接return
      if (
        !this.page.customerGuid ||
        !this.inputTime ||
        !this.goodsList?.length
      ) {
        return;
      }
      if (this.checkProFlg == 1) return;
      this.checkProFlg = 1;
      let params = {
        redisKey: JSON.parse(localStorage.BHOTC_redisKey),
        guid: this.$route.query.guid || "", //编辑时的guid
        orderNo: this.page.orderNo || "", //编辑时的订单编号
        isEditOrder: this.$route.query.guid ? true : false,
        tenantGuid: localStorage.guid,
        orderType: this.page.orderType,
        inputTime:
          this.$moment(self.inputTime).format("YYYY-MM-DD") + this.getHMS(),
        customerGuid: this.page.customerGuid, //otc药店
        customerName: this.page.customerName,
        objectType: "1",
        franchiseeGuid: this.page.franchiseeGuid || "", //商业公司
        goodsBasisList: this.handleGoods(this.goodsList),
        taskDetailGuid: this.taskDetailGuid || null,
      };
      // 调接口
      const { data } = await this.api.postJson(
        `/${serverConfig.msPurchaseService}/order-valid/check-otc-sy-order`,
        params
      );
      this.checkProFlg = 0;

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      if (data.data) {
        this.$message.error({
          message: data.data,
        });
      }
    },
    handleGoods(list) {
      const goodsData = list.map((item) => {
        const { goodsName, goodsSpec, producer } = item;

        if (this.declareGoodsType == "2" && this.isCompetitor == "N") {
          const { goodsGuid, goodsLotGuid } = item;
          return { goodsGuid, goodsLotGuid, goodsName, goodsSpec, producer };
        } else {
          const { guid } = item;
          return { goodsGuid: guid, goodsName, goodsSpec, producer };
        }
      });

      return goodsData;
    },
    handleGoods(list) {
      const goodsData = list.map((item) => {
        const { goodsName, goodsSpec, producer } = item;
        if (this.declareGoodsType == "2" && this.isCompetitor == "N") {
          const { goodsGuid, goodsLotGuid } = item;
          return { goodsGuid, goodsLotGuid, goodsName, goodsSpec, producer };
        } else {
          const { guid } = item;
          return { goodsGuid: guid, goodsName, goodsSpec, producer };
        }
      });

      return goodsData;
    },
    getHMS() {
      let str = "";
      let date = new Date();
      let hh = date.getHours(); //小时
      let mm = date.getMinutes(); //分
      let ss = date.getSeconds();
      if (hh < 10) {
        hh = "0" + hh;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (ss < 10) {
        ss = "0" + ss;
      }
      str = " " + hh + ":" + mm + ":" + ss;
      return str;
    },
    async getDetail() {
      let guid = this.$route.query.guid;
      const { data } = await this.api.get(
        `/${serverConfig.msPurchaseService}/order/data/get-order-detail?guid=${guid}`
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      let detailData = data.data;
      this.checkProFlg = 1; //防止编辑进入的反复调用checkProduct
      this.inputTime = this.$moment(detailData.inputTime).format("YYYY-MM-DD");
      this.page = {
        ...this.page,
        customerName: detailData.customerName,
        customerGuid: detailData.customerGuid,
        franchiseeGuid: detailData.franchiseeGuid,
        franchiseeName: detailData.franchiseeName,
        orderNo: detailData.orderNo,
        memo: detailData.memo,
      };
      this.goodsList = (detailData.orderDetailVOs || []).map((item) => {
        return {
          ...item,
          bigUnitQty: +item.qty,
          guid: item.goodsGuid,
        };
      });
      // this.goodsList.forEach((item) => {
      //   item.bigUnitQty = +item.qty;
      //   item.guid = item.goodsGuid;
      // });
      this.pageTable.totalRows = this.goodsList.length;
      this.pageTable.totalPage =
        (this.pageTable.totalRows + this.pageTable.pageSize - 1) /
        this.pageTable.pageSize;
      // this.checkProFlg=0//放在getTaskList后面
      await this.getMedical("");
      await this.getAccepted("");
      this.handleCounterChange();
      await this.getTaskList(this.inputTime, detailData.taskDetailGuid);
      const bizParam = JSON.parse(localStorage.getItem('BHOTC_bizParam') || '{}');
      if (bizParam.accountMonthCheckRule?.enabled) {
        this.setDatePickerOptions(bizParam.accountMonthCheckRule)
      } else {
        this.setDatePickerByTaskRange()
      }
    },
    cancelDialog() {
      this.$refs.dataTable.clearSelection();
      this.dialogFormVisible = false;
    },
    //选择药店
    openMedDialog() {
      if (this.taskTitleAndTaskContentName == "" && this.taskList.length) {
        this.$message.error("请选择任务！");
        return;
      }
      this.medDialog = true;
      this.$nextTick(() => {
        this.$refs.medTableRef.clearSelection();
      });
      this.getMedList(1);
    },
    async getMedList(val) {
      let self = this;
      let medQueryPage = this.medQueryPage;
      let userInfo = JSON.parse(localStorage.userInfo);
      if (val) {
        medQueryPage.pageIndex = 1;
      }
      if (this.isThirdPartyContractor) {
        medQueryPage.clientTenantGuid = self.$route.query.tenantGuid; // 任务包携带的 id
        medQueryPage.isNewService = "Y";
      }
      let esquerylist = this.getFieldConfig("isEsQuery", "selectItemList");
      let isEsQuery = esquerylist && esquerylist[0].value == "Y" ? "Y" : "N";
      this.isEsQuery = isEsQuery;
      if (isEsQuery == "Y") {
        const resp = await self.api.get(
          `/${serverConfig.msSalesPerformService}/sales-territory/data/get-staff-provinces?staffGuid=${userInfo.staffGuid}`
        );
        medQueryPage.provinces =
          (medQueryPage.provinces && medQueryPage.provinces.length) ||
          (medQueryPage.city && medQueryPage.city.length)
            ? medQueryPage.provinces
            : resp.data.data;
        medQueryPage.city = medQueryPage.city;
        medQueryPage.keyword = medQueryPage.customerName;
        medQueryPage.customerName = null;
        medQueryPage.customerType = "1";
        medQueryPage.salesTerritoryGuidList = null;
        medQueryPage.cityLevelList = this.getLevel(1)
          ? JSON.parse(this.getLevel(1))
          : null; //城市等级
        const { data } = await self.api.postJson(
          `/${serverConfig.msCustomerService}/customer/get-customer-es`,
          medQueryPage
        );
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(data.msg);
          return;
        }
        self.medList = data.data.records;
        self.medQueryPage.totalRows = data.data.totalRows;
        self.medList.forEach((item) => {
          if (self.page.customerGuid == item.commonGuid) {
            self.$refs.medTableRef.toggleRowSelection(item, true);
          }
        });
      }
      if (isEsQuery != "Y") {
        medQueryPage.provinces = null;
        medQueryPage.city = null;
        medQueryPage.cityLevelList = this.getLevel(1)
          ? JSON.parse(this.getLevel(1))
          : null; //城市等级
        medQueryPage.competenceParam = this.getCompetenceType(1);
        // medQueryPage里的salesTerritoryGuidList不确定别的地方要不要，当前这种情况不需要，dekete掉
        if (medQueryPage.salesTerritoryGuidList) {
          delete medQueryPage.salesTerritoryGuidList;
        }
        const { data } = await self.api.postJson(
          `/${serverConfig.msCustomerService}/customer/data/get`,
          medQueryPage
        );
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(data.msg);
          return;
        }
        self.medList = data.data.records;
        self.medQueryPage.totalRows = data.data.totalRows;
        self.medList.forEach((item) => {
          if (self.page.customerGuid == item.guid) {
            self.$refs.medTableRef.toggleRowSelection(item, true);
          }
        });
      }
    },
    handleMedSizeChange(val) {
      this.medQueryPage.pageSize = val;
      this.getMedList();
    },
    handleMedCurrentChange(val) {
      this.medQueryPage.pageIndex = val;
      this.getMedList();
    },
    medSure() {
      if (
        !this.currentMedSelectRow.guid &&
        !this.currentMedSelectRow.commonGuid
      ) {
        this.$message.error("请选择药店！");
      } else {
        let guid =
          this.currentMedSelectRow.guid || this.currentMedSelectRow.commonGuid;
        let name = this.currentMedSelectRow.customerName;
        this.checkRule(guid, name);
        // this.medDialog = false;
      }
    },
    async checkRule(guid, name) {
      //校验规则
      let userinfo = localStorage.userInfo
        ? JSON.parse(localStorage.userInfo)
        : {};
      //编辑任务guid
      let bizGuid = this.$route.query.guid;
      let req = {
        redisKey: JSON.parse(localStorage.BHOTC_redisKey),
        bizGuid,
        customerType: 1,
        bizDate: this.inputTime, //报货时间
        customerGuid: guid,
        customerName: name,
        userGuid: userinfo.userGuid,
        tenantGuid: localStorage.guid,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/common/limit-rule-check`,
        req
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        retuen;
      }
      if (data.data) {
        //去掉选择的对象
        this.$refs.medTableRef.clearSelection();
        this.$message.error(data.data);
      }

      if (!data.data) {
        //校验通过
        this.page.customerGuid = guid;
        this.page.customerName = name;
        this.medDialog = false;
      }
    },
    handleClickMed(row, col, event) {
      this.$refs.medTableRef.clearSelection();
      row.flag = !row.flag;
      this.$refs.medTableRef.toggleRowSelection(row, row.flag);
      this.currentMedSelectRow = row;
    },

    handleSelectMed(selection, row) {
      this.$refs.medTableRef.clearSelection();
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.currentMedSelectRow = row;
        this.$refs.medTableRef.toggleRowSelection(row, true);
      }
    },
    handleMedProvinceAndCity() {
      this.$nextTick(() => {
        let arr = this.$refs["cascaderAddr"].getCheckedNodes();
        let newList = [];
        this.medQueryPage.provinces = [];
        this.medQueryPage.city = [];
        arr.forEach((item) => {
          if (
            (item.level == 1 && item.label == "北京市") ||
            (item.level == 1 && item.label == "上海市") ||
            (item.level == 1 && item.label == "重庆市") ||
            (item.level == 1 && item.label == "天津市")
          ) {
            this.medQueryPage.provinces.push(item.label);
          } else if (
            item.level == 2 &&
            item.label != "市辖区" &&
            item.label != "县"
          ) {
            this.medQueryPage.city.push(item.label);
          }
        });
      });
    },

    // 选择商业公司
    openFranchiseeDialog() {
      if (this.taskTitleAndTaskContentName == "" && this.taskList.length) {
        this.$message.error("请选择任务！");
        return;
      }
      this.franchiseeDialog = true;
      this.$nextTick(() => {
        this.$refs.franchiseeTableRef.clearSelection();
      });
      this.getFranchiseeList(1);
    },
    async getFranchiseeList(val) {
      let self = this;
      let franchiseeQueryPage = this.franchiseeQueryPage;
      let userInfo = JSON.parse(localStorage.userInfo);
      if (val) {
        franchiseeQueryPage.pageIndex = 1;
      }
      if (this.isThirdPartyContractor) {
        franchiseeQueryPage.clientTenantGuid = self.$route.query.tenantGuid; // 任务包携带的 id
        franchiseeQueryPage.isNewService = "Y";
      }
      let esquerylist = this.getFieldConfig("isEsQuery", "selectItemList");
      let isEsQuery = esquerylist && esquerylist[0].value == "Y" ? "Y" : "N";
      this.isEsQuery = isEsQuery;
      if (isEsQuery == "Y") {
        const resp = await self.api.get(
          `/${serverConfig.msSalesPerformService}/sales-territory/data/get-staff-provinces?staffGuid=${userInfo.staffGuid}`
        );
        franchiseeQueryPage.provinces =
          (franchiseeQueryPage.provinces &&
            franchiseeQueryPage.provinces.length) ||
          (franchiseeQueryPage.city && franchiseeQueryPage.city.length)
            ? franchiseeQueryPage.provinces
            : resp.data.data;
        franchiseeQueryPage.city = franchiseeQueryPage.city;
        franchiseeQueryPage.keyword = franchiseeQueryPage.franchiseeName;
        franchiseeQueryPage.franchiseeName = null;
        franchiseeQueryPage.customerType = "2";
        franchiseeQueryPage.salesTerritoryGuidList = null;
        franchiseeQueryPage.cityLevelList = this.getLevel(1)
          ? JSON.parse(this.getLevel(1))
          : null; //城市等级
        const { data } = await self.api.postJson(
          `/${serverConfig.msCustomerService}/customer/get-customer-es`,
          franchiseeQueryPage
        );
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(data.msg);
          return;
        }
        self.franchiseeList = data.data.records;
        self.franchiseeQueryPage.totalRows = data.data.totalRows;
      }
      if (isEsQuery != "Y") {
        franchiseeQueryPage.provinces = null;
        franchiseeQueryPage.city = null;
        franchiseeQueryPage.cityLevelList = this.getLevel(1)
          ? JSON.parse(this.getLevel(1))
          : null; //城市等级
        franchiseeQueryPage.competenceParam = this.getCompetenceType(2);
        // franchiseeQueryPage里的salesTerritoryGuidList不确定别的地方要不要，当前这种情况不需要，dekete掉
        if (franchiseeQueryPage.salesTerritoryGuidList) {
          delete franchiseeQueryPage.salesTerritoryGuidList;
        }
        const { data } = await self.api.postJson(
          `/${serverConfig.msCustomerService}/franchisee/data/get`,
          franchiseeQueryPage
        );
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(data.msg);
          return;
        }
        self.franchiseeList = data.data.records;
        self.franchiseeQueryPage.totalRows = data.data.totalRows;
      }
      self.franchiseeList.forEach((item) => {
        if (item.commonGuid == self.page.franchiseeGuid) {
          self.$refs.franchiseeTableRef.toggleRowSelection(item, true);
        }
      });
    },
    //获取权限类型
    getCompetenceType(type) {
      let params = "";
      const visitRadioListMap = localStorage.getItem("BHOTC_bizParam")
        ? JSON.parse(localStorage.getItem("BHOTC_bizParam"))
        : {};
      const visitRadioList =
        visitRadioListMap && visitRadioListMap.visitRadioList
          ? visitRadioListMap.visitRadioList
          : [];
      if (visitRadioList.length > 0) {
        visitRadioList.forEach((i) => {
          if (type == i.type) {
            params = i.competenceParam;
          }
        });
      }
      return params;
    },
    handleFranchiseeSizeChange(val) {
      this.franchiseeQueryPage.pageSize = val;
      this.getFranchiseeList();
    },
    handleFranchiseeCurrentChange(val) {
      this.franchiseeQueryPage.pageIndex = val;
      this.getFranchiseeList();
    },
    franchiseeSure() {
      if (
        !this.currentFranchiseeSelectRow.guid &&
        !this.currentFranchiseeSelectRow.commonGuid
      ) {
        this.$message.error("请选择商业公司！");
      } else {
        this.page.franchiseeGuid =
          this.currentFranchiseeSelectRow.guid ||
          this.currentFranchiseeSelectRow.commonGuid;
        this.page.franchiseeName =
          this.currentFranchiseeSelectRow.franchiseeName ||
          this.currentFranchiseeSelectRow.customerName;
        this.franchiseeDialog = false;
      }
    },
    handleClickFranchisee(row, col, event) {
      this.$refs.franchiseeTableRef.clearSelection();
      row.flag = !row.flag;
      this.$refs.franchiseeTableRef.toggleRowSelection(row, row.flag);
      this.currentFranchiseeSelectRow = row;
    },
    handleSelectFranchisee(selection, row) {
      this.$refs.franchiseeTableRef.clearSelection();
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.currentFranchiseeSelectRow = row;
        this.$refs.franchiseeTableRef.toggleRowSelection(row, true);
      }
    },
    handleFranchiseeProvinceAndCity() {
      this.$nextTick(() => {
        let arr = this.$refs["cascaderAddr"].getCheckedNodes();
        this.franchiseeQueryPage.provinces = [];
        this.franchiseeQueryPage.city = [];
        arr.forEach((item) => {
          if (
            (item.level == 1 && item.label == "北京市") ||
            (item.level == 1 && item.label == "上海市") ||
            (item.level == 1 && item.label == "重庆市") ||
            (item.level == 1 && item.label == "天津市")
          ) {
            this.franchiseeQueryPage.provinces.push(item.label);
          } else if (
            item.level == 2 &&
            item.label != "市辖区" &&
            item.label != "县"
          ) {
            this.franchiseeQueryPage.city.push(item.label);
          }
        });
      });
    },
    getLevel(type) {
      if (this.taskContentJson) {
        let taskContent = JSON.parse(this.taskContentJson);
        return type == 1 ? taskContent.cityLevel : taskContent.medLevel;
      } else {
        return null;
      }
    },
    transform(list) {
      if (!list?.length) return;
      const newList = list.map((item) => {
        return {
          name: item.text,
          value: item.value,
        };
      });
      return newList;
    },
    getFieldConfig(params, key) {
      const fieldList = JSON.parse(localStorage.getItem("BHOTC_CONFIG"));
      const newConfig = fieldList.find((item) => item.fieldName == params);
      return newConfig && newConfig[key];
    },

    async getFormConfig() {
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        functionCode: "BHOTC",
        tenantGuid: localStorage.guid,
        organisationGuid: userInfo.organisationGuid,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msConfigureService}/function/function-tenant-field/get-config`,
        query
      );
      this.isInitConfig = true;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      localStorage.setItem("BHOTC_CONFIG", JSON.stringify(data.data.fieldList));
      localStorage.setItem(
        "BHOTC_redisKey",
        JSON.stringify(data.data.redisKey)
      );
      localStorage.setItem(
        "BHOTC_bizParam",
        JSON.stringify(data.data.bizParam)
      );
      this.declareGoodsType =
        JSON.parse(localStorage.getItem("BHOTC_bizParam")).declareGoodsType ||
        "1";
      this.isIntercept = this.getHolidayType("1", "BHOTC_bizParam", 1);
      this.isChangePrice = data.data.bizParam.isChangePrice;
    },
    selectDisableRoom(row) {
      if (
        (this.isChangePrice == 0 && row.priceType == 2) ||
        (this.isChangePrice == 0 && row.priceType == 1 && row.price == 0) ||
        (this.isChangePrice == 0 && row.priceType == 1 && !row.price)
      ) {
        return false;
      } else {
        return true;
      }
    },
    sureTask() {
      if (!this.taskGuid) {
        this.$message.error("请选择任务！");
        return;
      }
      this.taskDialogVisible = false;
      this.submit();
    },
    // 获取拜访时间
    getVisitTime(res, flg) {
      //flg是重新获取节假日时间之后重新校验时间
      if (this.matchDate(res)) {
        if (this.isIntercept) {
          this.$message.error("节假日不可选择，请更换日期！");
          this.inputTime = null;
        } else {
          this.$confirm("您选择的是国家法定节假日，确定选择吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then((action) => {
              this.inputTime = res;
            })
            .catch(() => {
              this.inputTime = null;
            });
        }
      } else if(!flg){
        this.inputTime = res;
      }
      if (!flg && this.inputTime) {
        this.getTaskList(this.inputTime);
        this.getAccountMonth();
      }
    },
    // dateChange(val) {
    //   this.getTaskList(this.inputTime);
    //   this.getAccountMonth();
    //   // this.checkProduct()//放到任务列表后面，为了获取任务详情guid
    // },
    taskChange(val) {
      let taskList = this.taskList;
      taskList.forEach((item) => {
        if (item.taskTitleAndTaskContentName == val) {
          this.planCount = item.planCount;
          this.realCount = item.realCount;
          this.startTime = item.startTime;
          this.endTime = item.endTime;
          this.taskGuid = item.taskGuid;
          this.taskDetailGuid = item.taskDetailGuid;
          this.taskTotalUnit = item.taskTotalUnit;
          this.taskContentJson = item.taskContentJson;
          this.taskTitle = item.taskTitle;
          this.taskContentName = item.taskContentName;
          this.page.medName = "";
          this.page.medGuid = "";
          this.page.franchiseeGuid = "";
          this.page.franchiseeName = "";
        }
      });
      if (this.startTime && this.endTime) {
        this.inputTime = this.$moment(this.startTime).format('YYYY-MM-DD');
        const bizParam = JSON.parse(localStorage.getItem('BHOTC_bizParam') || '{}');
        if (bizParam.accountMonthCheckRule?.enabled) {
          this.setDatePickerOptions(bizParam.accountMonthCheckRule)
        } else {
          this.setDatePickerByTaskRange()
        }
        this.getAccountMonth();
      }
    },
    async getTaskList(taskTime, taskDetailGuid) {
      const self = this;
      const userInfo = JSON.parse(localStorage.userInfo);
      const query = {
        tenantGuid: self.$store.state.guid,
        staffGuid: userInfo.staffGuid,
        taskTime,
        taskContentType: "BHOTC",
      };
      const { data } = await self.api.postJson(
        `/${serverConfig.msSalesPerformService}/task/data/get-do-task-detail-list`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      this.taskTitleAndTaskContentName = "";
      this.realCount = "";
      this.planCount = "";
      this.startTime = "";
      this.endTime = "";
      this.taskGuid = "";
      this.taskDetailGuid = "";
      this.taskList = data.data?.map((item) => {
        return {
          ...item,
          taskTitleAndTaskContentName:
            item.taskTitle + " | " + item.taskContentName,
        };
      });
      if (this.taskList?.length) {
        this.planCount = this.taskList[0].planCount;
        this.realCount = this.taskList[0].realCount;
        this.taskGuid = this.taskList[0].taskGuid;
        this.taskContentName = this.taskList[0].taskContentName;
        this.taskTitle = this.taskList[0].taskTitle;
        this.taskDetailGuid = this.taskList[0].taskDetailGuid;
        this.taskTotalUnit = this.taskList[0].taskTotalUnit;
        this.taskTitleAndTaskContentName =
          this.taskList[0].taskTitleAndTaskContentName;
        this.taskContentJson = this.taskList[0].taskContentJson;
        this.startTime = this.taskList[0].startTime;
        this.endTime = this.taskList[0].endTime;
      }
      if (taskDetailGuid) {
        this.taskList.forEach((item) => {
          if (item.taskDetailGuid == taskDetailGuid) {
            this.planCount = item.planCount;
            this.realCount = item.realCount;
            this.taskGuid = item.taskGuid;
            this.taskContentName = item.taskContentName;
            this.taskTitle = item.taskTitle;
            this.taskDetailGuid = item.taskDetailGuid;
            this.taskTotalUnit = item.taskTotalUnit;
            this.taskTitleAndTaskContentName = item.taskTitleAndTaskContentName;
            this.taskContentJson = item.taskContentJson;
            this.startTime = item.startTime;
            this.endTime = item.endTime;
          }
        });
      }
      if (this.startTime && this.endTime && !this.$route.query.guid) {
        this.inputTime = this.$moment(this.startTime).format('YYYY-MM-DD');
        this.getAccountMonth();
        const bizParam = JSON.parse(localStorage.getItem('BHOTC_bizParam') || '{}');
        if (bizParam.accountMonthCheckRule?.enabled) {
          this.setDatePickerOptions(bizParam.accountMonthCheckRule)
        } else {
          this.setDatePickerByTaskRange()
        }
      }
      this.checkProFlg = 0;
      this.checkProduct();
    },
    handleCounterChange() {
      this.amountNum();
    },
    subAddQty(tab, index) {
      if (tab == 0) {
        //减法
        if (
          (this.goodsList[index].bigUnitQty < 1 &&
            this.goodsList[index].bigUnitQty > 0) ||
          this.goodsList[index].bigUnitQty == 0
        ) {
          this.goodsList[index].bigUnitQty = 0;
        } else {
          this.goodsList[index].bigUnitQty =
            +this.goodsList[index].bigUnitQty - 1;
        }
      }
      if (tab == 1) {
        //加法
        this.goodsList[index].bigUnitQty =
          +this.goodsList[index].bigUnitQty + 1;
      }
      this.goodsList[index].bigUnitQty = this.goodsList[index].bigUnitQty
        .toString()
        .match(/^\d+(?:\.\d{0,4})?/);
      this.amountNum();
    },
    //价格判断
    priceChange(row) {
      this.goodsList.forEach((i, index) => {
        if (i.guid == row.guid && row.priceType == "2") {
          if (row.price < row.minPrice || row.price > row.maxPrice) {
            this.$delete(i, "tip");
            this.$set(
              i,
              "tip",
              "需在" + row.minPrice + "~" + row.maxPrice + "之间"
            );
          } else {
            this.$delete(i, "tip");
            this.$set(i, "tip", null);
          }
        }
        if (i.goodsGuid == row.goodsGuid) {
          i.price = row.price;
        }
      });
      this.amountNum();
    },
    //下载模板
    downTemplate() {
      window.open("/批量报货导入模版.xlsx");
    },
    empty() {
      this.goodsList = [];
      this.multipleSelectionSelection = [];
      this.multipleChildSelection = [];
      this.pageTable = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      };
    },
    //获取报货客户
    async getMedical(v) {
      let self = this;
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        tenantGuid: self.$store.state.guid,
        pageIndex: 1,
        pageSize: 500,
        customerName: v,
        salesTerritoryGuidList: userinfo.salesTeritorys || null,
      };
      self.selectLoading = true;
      const { data } = await self.api.postJson(
        `/${serverConfig.msCustomerService}/customer/data/get`,
        query
      );
      self.selectLoading = false;

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.optionsMedical = data.data.records;
    },
    //获取商业公司
    async getAccepted(val) {
      const self = this;
      const userinfo = JSON.parse(localStorage.userInfo);
      const query = {
        // staffGuid: userinfo.staffGuid,
        tenantGuid: self.$store.state.guid,
        pageIndex: 1,
        pageSize: 100,
        franchiseeName: val,
      };
      const { data } = await self.api.postJson(
        `/${serverConfig.msCustomerService}/franchisee/data/get`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.optionsFranchisee = data.data.records;
    },
    //获取当天日期
    getNowTime() {
      let self = this;
      let now = new Date();
      let year = now.getFullYear(); // 得到年份
      let month = now.getMonth() + 1; // 得到月份
      let date = now.getDate(); // 得到日期
      let defaultDate = `${year}-${month < 10 ? "0" + month : month}-${
        date < 10 ? "0" + date : date
      }`;
      self.inputTime = defaultDate;
    },
    //搜索
    searchData() {
      let self = this;
      self.pages.pageIndex = 1;
      self.getData();
    },
    //总金额
    amountNum() {
      this.amount = 0;
      this.num = 0;
      for (let i = 0; i < this.goodsList.length; i++) {
        let price = this.goodsList[i].price || 0;
        let bigUnitQty = this.goodsList[i].bigUnitQty || 0;
        this.num = this.num + parseInt(bigUnitQty);
        this.amount += price * parseInt(bigUnitQty);
      }
    },
    //获取产品数据
    async getData() {
      let self = this;
      self.productInformationList = [];
      self.pages.tenantGuid = self.$store.state.guid;
      self.pages.staffGuid = JSON.parse(localStorage.userInfo).staffGuid;
      self.pages.taskDetailGuid = this.taskDetailGuid;
      if (this.taskContentJson) {
        let taskContent = JSON.parse(this.taskContentJson);
        self.pages.isCompetitor = taskContent.isCompetitor;
        self.isCompetitor = taskContent.isCompetitor;
      }
      if (self.declareGoodsType == "2" && self.isCompetitor == "N") {
        self.pages.isSelectLotNo = "Y";
      } else {
        self.pages.isSelectLotNo = "N";
      }
      const params = {
        ...self.pages,
        curTenantGuid: null,
      };
      let url = "/goods/data/get-my-unit-goods";
      if (self.isThirdPartyContractor) {
        url = "/goods/data/three-get-goods";
        params.curTenantGuid = localStorage.guid; // 当前用户的 tenantGuid
        params.tenantGuid = self.$route.query.tenantGuid; // 任务包的 tenantGuid
      }
      self.loading = true;

      const { data } = await self.api.postJson(
        `/${serverConfig.msProductService}${url}`,
        params
      );
      self.loading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.productInformationList = data.data.records;
      self.pages.totalPage = data.data.totalPages;
      self.pages.totalRows = data.data.totalRows;
      if (!self.productInformationList?.length) {
        return;
      }
      self.$nextTick(() => {
        self.productInformationList.forEach((item, index) => {
          item["bigUnitQty"] = 0;
          if (self.goodsList != null && self.goodsList.length > 0) {
            self.goodsList.forEach((i) => {
              if (item.guid == i.guid) {
                self.$refs.dataTable.toggleRowSelection(item, true);
              }
            });
          }
        });
      });
    },
    //提交
    async submit() {
      let self = this;
      self.page.tenantGuid = self.$store.state.guid;
      if (
        !this.inputTime &&
        this.getFieldConfig("inputTime", "formVisible") == "Y" &&
        this.getFieldConfig("inputTime", "isRequired") == "Y"
      ) {
        self.$message.error(
          `${this.getFieldConfig("inputTime", "fieldAlias")}不能为空`
        );
        return;
      }
      if (self.taskTitleAndTaskContentName == "" && this.taskList.length) {
        self.$message.error("请选择任务！");
        return;
      }
      if (
        !this.page.customerGuid &&
        this.getFieldConfig("customerName", "formVisible") == "Y" &&
        this.getFieldConfig("customerName", "isRequired") == "Y"
      ) {
        self.$message.error(
          `${this.getFieldConfig("customerName", "fieldAlias")}不能为空`
        );
        return;
      }
      if (
        !this.page.orderType &&
        this.getFieldConfig("orderType", "formVisible") == "Y" &&
        this.getFieldConfig("orderType", "isRequired") == "Y"
      ) {
        self.$message.error(
          `${this.getFieldConfig("orderType", "fieldAlias")}不能为空`
        );
        return;
      }
      if (!self.goodsList?.length) {
        self.$message.error("请选择商品！");
        return;
      }
      let flag = self.goodsList.some((item) => item.bigUnitQty == 0);
      // let flag1 = self.goodsList.some((k) => !k.price || k.tip);
      // if (flag1) {
      //   self.$message.error('请填写合理的商品价格！');
      //   return;
      // }
      if (flag) {
        self.$message.error("商品数量不能为0！");
        return;
      }
      if (self.page.orderType == "报货") {
        self.page["orderDetails"] = this.goodsList.map((item) => {
          const isSpecialCase =
            this.declareGoodsType == "2" && this.isCompetitor == "N";
          const goodsGuid = isSpecialCase ? item.goodsGuid : item.guid;
          const qty = Array.isArray(item.bigUnitQty)
            ? item.bigUnitQty[0]
            : item.bigUnitQty;
          const price = Number(item.price);
          return isSpecialCase
            ? { goodsGuid, goodsLotGuid: item.goodsLotGuid, qty, price }
            : { goodsGuid, qty, price };
        });
      }
      if (self.page.orderType == "退货") {
        self.page["orderDetails"] = this.goodsList.map((item) => {
          const isSpecialCase =
            this.declareGoodsType === "2" && this.isCompetitor === "N";
          const goodsGuid = isSpecialCase ? item.goodsGuid : item.guid;
          const qty =
            "-" +
            (Array.isArray(item.bigUnitQty)
              ? item.bigUnitQty[0]
              : item.bigUnitQty);
          const price = Number(item.price);
          return isSpecialCase
            ? { goodsGuid, goodsLotGuid: item.goodsLotGuid, qty, price }
            : { goodsGuid, qty, price };
        });
      }
      self.page.inputTime =
        self.$moment(self.inputTime).format("YYYY-MM-DD") + " 00:00:00";
      self.page.customerType = "1"; //BHOTC药店1 BHSY2

      self.page.taskGuid = this.taskGuid;
      self.page.taskDetailGuid = this.taskDetailGuid;
      self.page.objectType = "1";
      if (this.taskGuid) {
        let userInfo = JSON.parse(localStorage.userInfo);
        let taskItem = this.taskList.filter(
          (item) => item.taskDetailGuid == this.taskDetailGuid
        );
        await this.$confirm(
          `确定完成的是【${userInfo.staffName}】-【${taskItem[0].taskTitle}】-【${taskItem[0].taskContentName}】任务吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "返回修改",
          }
        );
        self.submitLoading = true;
        self.page.redisKey = JSON.parse(localStorage.BHOTC_redisKey);
        let reqUrl = `/${serverConfig.msPurchaseService}/order/data/add`;
        let reqType = "postJson";
        if (this.$route.query.guid) {
          reqType = "put";
          self.page.guid = this.$route.query.guid;
          reqUrl = `/${serverConfig.msPurchaseService}/order/data/update`;
        }
        const { data } = await self.api[reqType](reqUrl, self.page);
        self.submitLoading = false;
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(data.msg);
          return;
        }
        self.$message.success(messageConfig.SUBMIT_SUCCESS);
      }
      if (!this.taskGuid) {
        self.submitLoading = true;
        self.page.redisKey = JSON.parse(localStorage.BHOTC_redisKey);
        let reqUrl = `/${serverConfig.msPurchaseService}/order/data/add`;
        let reqType = "postJson";
        if (this.$route.query.guid) {
          reqType = "put";
          self.page.guid = this.$route.query.guid;
          reqUrl = `/${serverConfig.msPurchaseService}/order/data/update`;
        }
        const { data } = await self.api[reqType](reqUrl, self.page);

        self.submitLoading = false;
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(data.msg);
          return;
        }
        self.$message.success(messageConfig.SUBMIT_SUCCESS);

        self.amount = 0;
      }
      if (this.$route.query.guid) {
        this.$router.go(-1);
      }
      self.goodsList = [];
      self.pageTable = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      };
      self.getNowTime();
      await self.getTaskList(this.inputTime);
      self.page = {
        tenantGuid: "",
        orderNo: "",
        inputTime: "",
        franchiseeGuid: null,
        customerGuid: "",
        memo: "",
        orderDetails: [],
        orderType: "报货",
        customerType: "1", //BHOTC药店1 BHSY2
      };
    },
    //提交商品
    async submitForm() {
      let self = this;
      let list = [];
      // self.goodsList = JSON.parse(JSON.stringify(self.goodsList.concat(self.multipleSelection)));
      // self.productInformationList = self.productInformationList.filter((item) => {
      //   // 返回不在选中列表里面的项
      //   return !self.goodsList.find((k) => item.guid === k.guid);
      // });
      if (this.declareGoodsType == "2" && this.isCompetitor == "N") {
        self.multipleChildSelection = self.multipleChildSelection.filter(
          (item) => {
            // 返回不在选中列表里面的项
            return !self.goodsList.find(
              (k) => item.guid === k.guid && item.goodsGuid === k.goodsGuid
            );
          }
        );
        self.multipleChildSelection = self.multipleChildSelection.map(
          (item) => {
            const { tip, price, priceType } = item;
            return {
              ...item,
              tip: priceType == "2" ? null : tip,
              minPrice:
                priceType == "2" ? JSON.parse(JSON.stringify(price)) : 0,
              price: priceType == "2" ? "" : price,
            };
          }
        );
        list = JSON.parse(
          JSON.stringify(self.goodsList.concat(self.multipleChildSelection))
        );
      } else {
        self.multipleSelection = self.multipleSelection.filter((item) => {
          // 返回不在选中列表里面的项
          return !self.goodsList.find((k) => item.guid === k.guid);
        });
        self.multipleSelection = self.multipleSelection.map((item) => {
          const { tip, price, priceType } = item;
          return {
            ...item,
            tip: priceType == "2" ? null : tip,
            minPrice: priceType == "2" ? JSON.parse(JSON.stringify(price)) : 0,
            price: priceType == "2" ? "" : price,
          };
        });
        list = JSON.parse(
          JSON.stringify(self.goodsList.concat(self.multipleSelection))
        );
      }
      const params = {
        redisKey: JSON.parse(localStorage.BHOTC_redisKey),
        guid: this.$route.query.guid || "", //编辑时的guid
        orderNo: this.page.orderNo || "", //编辑时的订单编号
        isEditOrder: this.$route.query.guid ? true : false,
        tenantGuid: localStorage.guid,
        orderType: this.page.orderType,
        inputTime:
          this.$moment(self.inputTime).format("YYYY-MM-DD") + this.getHMS(),
        customerGuid: this.page.customerGuid, //otc药店
        objectType: "1",
        franchiseeGuid: this.page.franchiseeGuid || "", //商业公司
        goodsBasisList: this.handleGoods(list),
        taskDetailGuid: this.taskDetailGuid || null,
        accountMonth: this.accountMonth || null,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msPurchaseService}/order-valid/check-otc-sy-order-num`,
        params
      );

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }

      if (data.data) {
        this.$message.error({
          message: data,
        });
        return;
      }
      self.goodsList = list;
      if (self.goodsList && self.goodsList.length > 0) {
        self.goodsList.forEach((j) => {
          if (j.bigUnitQty == 0) {
            j.bigUnitQty = 1;
          }
        });
      }
      console.log("self.goodsList", self.goodsList);
      self.pageTable.totalRows = self.goodsList.length;
      self.pageTable.totalPage =
        (self.pageTable.totalRows + self.pageTable.pageSize - 1) /
        self.pageTable.pageSize;
      await self.checkProduct();
      self.dialogFormVisible = false;
      this.amountNum();
    },
    //获取核算月
    async getAccountMonth() {
      if (!this.inputTime) return;
      let self = this;
      let tenantGuid = localStorage.guid;
      const { data } = await this.api.get(
        `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month?date=` +
          this.inputTime +
          "&tenantGuid=" +
          tenantGuid
      );

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.accountMonth = data.data;
      self.getHoliday(self.inputTime, self.inputTime, 1);
    },
    add(flg, row) {
      let self = this;
      self.showBottom = false;
      if (self.page.customerGuid == "" || self.page.customerGuid == null) {
        self.$message.error("请先选择药店！");
      } else {
        self.getData();
        self.multipleChildSelection = [];
        self.multipleSelection = [];
        self.dialogFormVisible = true;
      }
    },
    //批量导入
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split(".");
      if (arr[1] !== "xls" && arr[1] !== "xlsx" && arr[1] !== "xlsm") {
        this.$message.error("上传文件只能是 excel/xls 格式!");
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    changeFile(file, fileList) {
      let self = this;
      self.fileList = [];
      self.fullscreenLoading = true;
      let formData = new FormData();
      formData.append("file", file.file); //传文件
      let importUrl = self.url;
      if (this.taskContentJson) {
        let taskContent = JSON.parse(this.taskContentJson);
        let isCompetitor = taskContent.isCompetitor;
        importUrl = importUrl + "&isCompetitor=" + isCompetitor;
      }
      self.api.postFile(importUrl, formData).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.goodsList = res.data.data;
          self.goodsList.forEach((item) => {
            self.$set(item, "bigUnitQty", self.getBit(item.bigUnitQty));
          });
          self.pageTable.totalRows = self.goodsList.length;
          self.pageTable.totalPage =
            (self.pageTable.totalRows + self.pageTable.pageSize - 1) /
            self.pageTable.pageSize;
          self.amountNum();
          let msg = res.data.msg.split(",");
          this.importResult = {
            total: msg[0],
            ok: msg[1],
            error: msg[2],
          };
          this.showImport = true;
        } else {
          self.$message({
            type: "warning",
            message: res.data.msg,
          });
          return false;
        }
      });
    },
    //下载失败数据
    async downFailData() {
      let req = {
        tenantGuid: this.$store.getters.getTenantGuid,
      };
      const { data } = await this.api.get(
        `/${serverConfig.msPurchaseService}/order/get-import-error-data`,
        req
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message({
          type: "error",
          message: data.msg,
        });
        return;
      }
      await this.reportJx(
        data.data.colNames,
        data.data.datas,
        data.data.sheetName,
        data.data.fileNam
      );
    },
    async reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      const { data } = await self.api.postJsonD(
        `/${serverConfig.msCommonAdminCloudService}/excel/export`,
        {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        }
      );
      let blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let fileName = fileNam;
      let objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.download = fileName;
      link.href = objectUrl;
      link.click();
      self.fullscreenLoading = false;
    },
    getBit(value) {
      const reg = /([0-9]+\.[0-9]{4})[0-9]*/;
      let str = value.toString();
      str = str.replace(reg, "$1");
      return str;
    },
    handleSizeChange(val) {
      let self = this;
      self.pageTable.pageSize = val;
    },
    handleCurrentChange(val) {
      let self = this;
      self.pageTable.pageIndex = val;
    },
    handleSizeChange1(val) {
      let self = this;
      self.pages.pageSize = val;
      this.getData();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.pages.pageIndex = val;
      this.getData();
    },
    getDelete(index, row) {
      let self = this;
      self.goodsList.splice(index, 1);
      this.pageTable.totalRows = this.goodsList.length;
      this.pageTable.totalPage =
        (this.pageTable.totalRows + this.pageTable.pageSize - 1) /
        this.pageTable.pageSize;
      // self.productInformationList.push(row);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectChild(selection, row) {
      console.log("selectChild", selection, row);
      let index = selection.findIndex((item) => item.guid == row.guid);
      console.log("index", index, this.multipleChildSelection);

      if (index < 0) {
        //取消选中
        // selection.push(row)
        this.multipleChildSelection = this.multipleChildSelection.filter(
          (i) => !(i.guid == row.guid) && i.goodsGuid == row.goodsGuid
        );
      } else {
        // selection.splice(index,1)
        // this.multipleChildSelection.push(row)
      }
    },
    selectChildAll(selection, parent) {
      console.log("selectChildAll");

      if (selection.length == 0) {
        this.multipleChildSelection = this.multipleChildSelection.filter(
          (i) => !(i.goodsGuid == parent.guid)
        );
      }
    },
    handleChildSelectionChange(val, row, index) {
      let self = this;
      console.log("e,row", val, row);
      if (val.length > 0) {
        val.forEach((item) => {
          item.goodsName = row.goodsName;
          item.goodsLotGuid = item.guid;
          (item.goodsSpec = row.goodsSpec),
            (item.producer = row.producer),
            (item.goodsCode = row.goodsCode),
            (item.pictContent = row.pictContent),
            (item.unitStyle = row.unitStyle),
            (item.minPrice = row.price || 0),
            (item.tip = row.tip),
            (item.priceType = row.priceType),
            (item.price = row.price);
          // item.num= row.num
          item.bigUnitQty = row.bigUnitQty;

          self.multipleChildSelection.push(item);
        });
      }

      self.multipleChildSelection = Array.from(
        new Set(self.multipleChildSelection)
      );
      // self.multipleChildSelection = val;
      // this.multipleChildSelection[index] = val;
      console.log("multipleChildSelection", this.multipleChildSelection);
    },
    getAllNestedSelections() {
      // 获取所有嵌套表格的选择结果
      return this.tableData.map((data, index) => {
        const nestedTable = this.$refs[`nestedTable-${index}`];
        if (nestedTable && nestedTable[0]) {
          // 嵌套表格存在时获取其选择
          return nestedTable[0].selection;
        }
        return []; // 嵌套表格不存在时返回空数组
      });
      // .flat(); // 使用flat方法将二维数组变为一维,暂时不转成一维
    },
    handleClickPro(row, col, event) {
      if (!(this.declareGoodsType == "2" && this.isCompetitor == "N")) return;
      // this.$refs.dataTable.clearSelection();
      row.flag = !row.flag;
      //如果是关闭的话，注意是否要清空批号
      this.$refs.dataTable.toggleRowSelection(row, row.flag);
      if (this.declareGoodsType == "2" && this.isCompetitor == "N") {
        this.$refs.dataTable.toggleRowExpansion(row, row.flag);
      }

      // this.currentMedSelectRow = row;
    },

    handleSelectPro(selection, row) {
      // this.$refs.dataTable.clearSelection();
      console.log("selection", selection);
      if (!(this.declareGoodsType == "2" && this.isCompetitor == "N")) return;
      if (selection.length == 0) {
        return;
      }
      if (row && this.declareGoodsType == "2" && this.isCompetitor == "N") {
        // this.currentMedSelectRow = row;
        this.$refs.dataTable.toggleRowExpansion(row, true);
      }
    },
    // todo 展开扩展表
    //  toogleExpand(row) {
    //   let tableRef = this.$refs.dataTable;
    //   // tableRef.toggleRowExpansion(row);
    // },
  },
};
</script>
<style scoped>
.content-main-box {
  height: auto;
  overflow-y: auto;
}
.no-data {
  width: 364px;
  height: 200px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 40px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bottom-total {
  box-sizing: border-box;
  position: fixed;
  width: calc(100% - 235px);
  height: 64px;
  bottom: 0;
  right: 0;
  padding-left: 18px;
  background: #fff;
  /* box-shadow: 4px 5px 6px 7px rgba(0, 0, 0, 0.3); */
  z-index: 99;
  overflow: hidden;
  border: 1px solid #e3e4e6;
  /* border-radius: 6px; */
}

.total-left {
  line-height: 32px;
}

.el-select-dropdown__item.selected {
  color: #333;
  font-weight: 400;
}

.upload-demo {
  width: 145px;
}

.task-tips {
  margin-right: 20px;
  float: right;
  max-width: 610px;
  margin-top: 8px;
}

.task-tips span {
  margin-right: 10px;
}

.taskDialog /deep/ .el-dialog__body {
  padding: 0;
  padding-top: 20px;
}

.taskDialog /deep/ .el-dialog__footer {
  padding-top: 0;
}

.taskDialog /deep/ .el-form-item {
  margin-bottom: 10px;
}

.taskDialog /deep/ .el-form-item:first-child {
  margin-bottom: 20px;
}

.tip-class {
  display: inline-block;
  color: red;
  font-size: 12px;
  text-align: left;
}

.price-input /deep/ .el-input__inner {
  text-align: right;
}

.select-tip {
  color: rgb(248, 93, 93);
  font-size: 12px;
  margin: 0;
}

.qty-wrap {
  display: flex;
  align-items: center;
}

.qty-wrap .btn {
  font-size: 16px;
  border: 1px solid #dcdfe6;
  width: 60px;
  height: 32px;
  line-height: 27px;
  cursor: pointer;
}

.qty-wrap .btn.btn0 {
  border-right: 0 none;
  border-radius: 4px 0 0 4px;
}

.qty-wrap .btn.btn1 {
  border-left: 0 none;
  border-radius: 0px 4px 4px 0px;
}

.importClass .secondStep {
  margin-top: 50px;
  height: 200px;
}

.importClass .secondStep .line1 {
  font-size: 20px;
}

.importClass .secondStep .line2 {
  font-size: 16px;
}

.importClass .secondStep .line2 span {
  color: #4fa1a4;
}

.importClass .secondStep .line3 {
  text-decoration: underline;
  cursor: pointer;
}

.search-area-div {
  margin-bottom: 8px;
}
</style>
<style>
.qty-wrap .el-input__inner {
  border-radius: 0;
}
</style>
